import { publicHref } from '../seo/linkHref';

/**
 * Markdown-style [label](/path) or [label](https://…) for blog body copy.
 * Internal hrefs come back in their prerendered slash form (publicHref).
 */

const LINK_RE = /\[([^\]]+)\]\((\/[^)\s]+|https?:\/\/[^)\s]+)\)/g;

export function stripInlineLinks(text) {
  return String(text || '').replace(LINK_RE, '$1');
}

export function splitInlineLinks(text) {
  const str = String(text || '');
  const parts = [];
  let last = 0;
  const re = new RegExp(LINK_RE.source, 'g');
  let match;
  while ((match = re.exec(str))) {
    if (match.index > last) {
      parts.push({ type: 'text', value: str.slice(last, match.index) });
    }
    parts.push({ type: 'link', label: match[1], href: publicHref(match[2]) });
    last = match.index + match[0].length;
  }
  if (last < str.length) {
    parts.push({ type: 'text', value: str.slice(last) });
  }
  if (!parts.length && str) {
    parts.push({ type: 'text', value: str });
  }
  return parts;
}
